module.exports = __webpack_public_path__ + "media/images/icons/icon_line-d982164dddbf5709f63592eef2ad139c.svg";